"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sodium = require("libsodium-wrappers-sumo");
var MacKey = (function () {
    function MacKey(key) {
        this.key = key;
    }
    MacKey.prototype.sign = function (msg) {
        return sodium.crypto_auth_hmacsha256(msg, this.key);
    };
    MacKey.prototype.verify = function (signature, msg) {
        var verify = sodium.crypto_auth_hmacsha256_verify(signature, msg, this.key);
        return verify;
    };
    MacKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return encoder.bytes(this.key);
    };
    MacKey.decode = function (decoder) {
        var key_bytes = new Uint8Array([]);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    key_bytes = new Uint8Array(decoder.bytes());
                    break;
                default:
                    decoder.skip();
            }
        }
        return new MacKey(key_bytes);
    };
    return MacKey;
}());
exports.default = MacKey;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/derived/MacKey.js
// module id = 45
// module chunks = 0 1